import { Shield, Lock, Globe2, Mail, Anchor } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#A1AEC2]/15 bg-[#060C1F] mt-24" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <Shield className="w-5 h-5 text-[#D4AF37]" />
            <span className="font-display font-black tracking-widest">A&amp;P FAST TRACK</span>
          </div>
          <p className="text-sm text-[#9EABC0] leading-relaxed">
            Offshore &amp; global high-value logistics — trusted by energy majors, central banks, museums, and Fortune 500 firms.
          </p>
        </div>

        <div>
          <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Operations</div>
          <ul className="space-y-3 text-sm text-[#9EABC0]">
            <li><Link to="/services" className="hover:text-[#F0F4F8]">Armored Transport</Link></li>
            <li><Link to="/services" className="hover:text-[#F0F4F8]">Precious Vaulting</Link></li>
            <li><Link to="/services" className="hover:text-[#F0F4F8]">Tech Logistics</Link></li>
            <li><Link to="/services" className="hover:text-[#F0F4F8]">Customs Management</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Client</div>
          <ul className="space-y-3 text-sm text-[#9EABC0]">
            <li><Link to="/track" className="hover:text-[#F0F4F8]">Track Shipment</Link></li>
            <li><Link to="/coverage" className="hover:text-[#F0F4F8]">Global Coverage</Link></li>
            <li><Link to="/contact" className="hover:text-[#F0F4F8]">Request Quote</Link></li>
            <li><Link to="/login" className="hover:text-[#F0F4F8]">Admin Portal</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Secure Contact</div>
          <ul className="space-y-3 text-sm text-[#9EABC0]">
            <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> ops@apfasttrack.com</li>
            <li className="flex items-center gap-2"><Anchor className="w-4 h-4" /> Offshore Operations Desk</li>
            <li className="flex items-center gap-2"><Globe2 className="w-4 h-4" /> 47 Command Centers</li>
            <li className="flex items-center gap-2"><Lock className="w-4 h-4" /> ISO 27001 Certified</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#A1AEC2]/10">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#9EABC0]">
            © 2026 A&amp;P Fast Track Services · All Movements Encrypted
          </div>
          <div className="flex items-center gap-6 font-mono text-[10px] uppercase tracking-[0.3em] text-[#9EABC0]">
            <span>ISO 27001</span>
            <span>TAPA Class A</span>
            <span>C-TPAT</span>
            <span>IATA CEIV</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
